import { render, staticRenderFns } from "./GlossaryLinkedCulturesModal.vue?vue&type=template&id=0bcbfe3c&"
import script from "./GlossaryLinkedCulturesModal.vue?vue&type=script&lang=js&"
export * from "./GlossaryLinkedCulturesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports